import { extractErrorMessage, isPromiseLike } from '@augment-vir/common';
// full function type
export function renderAsyncState(asyncState, 
/** This value will be rendered if the async state has not settled yet. */
fallback, resolutionRender, errorRender) {
    if (asyncState instanceof Error) {
        const errorResult = errorRender
            ? errorRender(asyncState)
            : extractErrorMessage(asyncState);
        return errorResult;
    }
    else if (isPromiseLike(asyncState)) {
        const fallbackResult = fallback;
        return fallbackResult;
    }
    else {
        const resolutionResult = resolutionRender
            ? resolutionRender(asyncState)
            : asyncState;
        return resolutionResult;
    }
}
